// import { defaultsDeep } from 'lodash';

/**
 * 
 */
class WMUSelect extends EventTarget {

	/**
	 * 
	 */
	constructor( element, args = {} )
	{
		super();

		this._keyboardNavIndex = null;

		this.selectElement = element;
		this.selectId = '';
		this.selectName = '';
		this.selectMultiple = false;
		this.selectOptions = null;
		this.label = '';
		this.selection = null;

		this.wmuSelectElement = null;
		this.wmuSelectUIElement = null;
		this.wmuSelectLabelElement = null;
		this.wmuSelectSelectionElement = null;
		this.wmuSelectOptionsElement = null;
		this.wmuSelectOptionElementList = [];

		this.args = {
			init: true,
			isOpen: false,
			isMultiple: null,
			...args
		};
		
		this.isInit = false;
		this.isOpen = this.args.isOpen;
		this.isMultiple = this.args.isMultiple;
		this.isKeyboardControlsActive = false;
		this.keydownTime = 0;
		this.searchString ='';

		if ( true === this.args.init )
		{
			this.init();
		}
	}

	/**
	 * 
	 */
	get keyboardNavIndex()
	{
		if ( null === this._keyboardNavIndex )
		{
			// Ici on retourne l'index du premier élément sélectionné ou 0 si pas de sélection
			if ( ! this.selection || ( this.isMultiple && this.selection.length === 0 ) )
			{
				return 0;
			}
			else
			{
				const searchValue = ( this.isMultiple ) ? this.selection[0] : this.selection;
				const countOptions = this.wmuSelectOptionElementList.length;
				for ( let i = 0; i < countOptions; i++ )
				{
					if ( searchValue === this.wmuSelectOptionElementList[i].getAttribute( 'value' ) )
					{
						return i;
					}
				}
			}
		}

		return this._keyboardNavIndex;
	}

	/**
	 * 
	 */
	set keyboardNavIndex( value )
	{
		const countOptions = this.wmuSelectOptionElementList.length;

		if ( value < 0 )
		{
			value = countOptions - value;
		}
		else if ( value >= countOptions )
		{
			value = value - countOptions;
		}

		this._keyboardNavIndex = Math.max( 0, Math.min( value, countOptions - 1 ) );
	}

	/**
	 * Initialize the select replacement
	 * 
	 * @returns void
	 */
	init()
	{
		if ( this.selectElement && ( 'select' === this.selectElement.nodeName.toLowerCase() || 'select' === this.selectElement.tagName.toLowerCase() ) )
		{
			this.selectId = this.selectElement.getAttribute( 'id' );
			this.selectName = this.selectElement.getAttribute( 'name' );
			this.selectMultiple = ( this.selectElement.getAttribute( 'multiple' ) ) ? true : false;
			this.selectOptions = this.selectElement.querySelectorAll( 'option' );
			this.label = this.findLabel();
			this.selection = this.findSelection();

			this.isMultiple = ( null === this.isMultiple ) ? this.selectMultiple : this.isMultiple;

			this.render();
			this.updateStatus();
			this.updateSelection();
			this.initBehaviors();

			this.selectElement.classList.add( 'wmu-select-replaced' );
			this.selectElement.dispatchEvent( new CustomEvent( 'replaced', { detail: {
				wmuSelect: this
			} } ) );
			this.selectElement.wmuSelect = this;
			this.isInit = true;
		}
		else
		{
			console.log( "No select element or invalid one." );
		}
	}

	/**
	 * Render the select replacement
	 * 
	 * @returns void
	 */
	render()
	{
		this.wmuSelectElement = document.createElement( 'div' );
		this.wmuSelectElement.classList.add( 'wmu-select' );
		this.wmuSelectElement.setAttribute( 'data-id', this.selectId );
		this.wmuSelectElement.setAttribute( 'data-name', this.selectName );
		if ( this.selectMultiple )
		{
			this.wmuSelectElement.setAttribute( 'data-multiple', 'multiple' );
		}

		this.wmuSelectUIElement = document.createElement( 'div' );
		this.wmuSelectUIElement.classList.add( 'wmu-select-ui' );
		this.wmuSelectElement.appendChild( this.wmuSelectUIElement );

		this.wmuSelectLabelElement = document.createElement( 'label' );
		this.wmuSelectLabelElement.classList.add( 'wmu-select-label' );
		this.wmuSelectLabelElement.innerHTML = this.label;
		this.wmuSelectUIElement.appendChild( this.wmuSelectLabelElement );

		this.wmuSelectSelectionElement = document.createElement( 'div' );
		this.wmuSelectSelectionElement.classList.add( 'wmu-select-selection' );
		this.wmuSelectUIElement.appendChild( this.wmuSelectSelectionElement );

		this.wmuSelectOptionsElement = document.createElement( 'div' );
		this.wmuSelectOptionsElement.classList.add( 'wmu-select-options' );
		this.wmuSelectElement.appendChild( this.wmuSelectOptionsElement );

		this.renderSelectChildren();
		// this.selectElement.parentNode.appendChild( this.wmuSelectElement );
		this.selectElement.parentNode.insertBefore( this.wmuSelectElement, this.selectElement );
	}
	
	/**
	 * 
	 */
	renderSelectChildren()
	{
		let child, element;
		const countChildren = this.selectElement.children.length;
		for ( let i = 0; i < countChildren; i++ )
		{
			child = this.selectElement.children[i];
			switch ( child.tagName.toLowerCase() )
			{
				case 'optgroup':
					element = this.renderOptgroup( child.getAttribute( 'label' ), child.children );
				break;

				case 'option':
					if ( null === child.getAttribute( 'value' ) )
					{
						continue;
					}
					element = this.renderOption( child.innerHTML, child.getAttribute( 'value' ) );
				break;
			}
			this.wmuSelectOptionsElement.appendChild( element );
		}
	}

	/**
	 * 
	 * @returns HTMLElement
	 */
	renderOption( content, value )
	{
		const element = document.createElement( 'div' );
		element.classList.add( 'wmu-select-option' );
		element.setAttribute( 'value', value );
		element.innerHTML = content;
		this.wmuSelectOptionElementList.push( element );
		return element;
	}

	/**
	 * 
	 * @returns HTMLElement
	 */
	renderOptgroup( groupLabel, optionElementList )
	{
		const optgroupElement = document.createElement( 'div' );
		optgroupElement.classList.add( 'wmu-select-optgroup' );

		const optgroupLabelElement = document.createElement( 'div' );
		optgroupLabelElement.classList.add( 'wmu-select-optgroup-label' );
		optgroupLabelElement.innerHTML = groupLabel;
		optgroupElement.appendChild( optgroupLabelElement );

		const optionsElement = document.createElement( 'div' );
		optionsElement.classList.add( 'wmu-select-optgroup-options' );
		optgroupElement.appendChild( optionsElement );

		const countOptions = optionElementList.length;
		for ( let i = 0; i < countOptions; i++ )
		{
			optionsElement.appendChild( this.renderOption( optionElementList[i].innerHTML, optionElementList[i].getAttribute( 'value' ) ) );
		}

		return optgroupElement;
	}

	/**
	 * 
	 */
	select( value, autoClose = true, updateRealSelect = true )
	{
		let change = false;

		if ( this.isMultiple )
		{
			const selectionIndex = this.selection.indexOf( value );

			if ( -1 === selectionIndex )
			{
				this.selection.push( value );
			}
			else
			{
				this.selection.splice( selectionIndex, 1 );
			}

			change = true;
		}
		else
		{
			if ( value != this.selection )
			{
				this.selection = value;
				change = true;
			}

			if ( true === autoClose )
			{
				this.close();
			}
		}

		this.updateSelection( updateRealSelect );

		if ( true === change )
		{
			this.dispatchEvent( new CustomEvent( 'change', { detail: {
				value: value,
				selection: this.selection,
				wmuSelect: this
			} } ) );
			
			this.selectElement.dispatchEvent( new CustomEvent( 'change', {
				bubbles: true,
				detail: {
					value: value,
					selection: this.selection,
					wmuSelect: this
				}
			} ) );
		}
	}

	/**
	 * 
	 */
	resetOptions()
	{
		this.selectElement.innerHTML = "";
		this.wmuSelectOptionsElement.innerHTML = "";
		this.wmuSelectOptionElementList = [];
		this.select( '' );
		this.selectOptions = null;
	}

	/**
	 * 
	 * @param {Object} options 
	 */
	setOptions( options )
	{
		this.resetOptions();

		Object.getOwnPropertyNames( options ).forEach( ( optionValue, index ) =>
		{
			const optionLabel = options[ optionValue ];
			const option = document.createElement( 'option' );
			option.setAttribute( 'value', optionValue );
			option.innerHTML = optionLabel;
			this.selectElement.appendChild( option );
		} );

		this.renderSelectChildren();
		
		/**
		 * @todo A revoir pour uniformiser ça au lieu de réécrire le même code que dans initBehaviors
		 */
		const countOptions = this.wmuSelectOptionElementList.length;
		for ( let i = 0; i < countOptions; i++ )
		{
			this.wmuSelectOptionElementList[i].addEventListener( 'click', ( event ) =>
			{
				this.select( this.wmuSelectOptionElementList[i].getAttribute( 'value' ) );
			} );
		}
	}

	/**
	 * 
	 */
	updateSelection( updateRealSelect = true )
	{
		let selection;

		if ( false === this.isMultiple )
		{
			selection = ( this.selection ) ? [ this.selection ] : [];
		}
		else
		{
			selection = this.selection;
		}

		this.wmuSelectSelectionElement.innerHTML = '';

		/**
		 * @todo Suivre l'ordre de la sélection. On pourrait le faire en établissant un tableau d'élément avec les selection-item
		 *       et en l'ordonnant lui en fonction de la sélection avant de l'insérer dans son espace.
		 */
		const countOptions = this.wmuSelectOptionElementList.length;
		for ( let i = 0, element; i < countOptions; i++ )
		{
			if ( -1 !== selection.indexOf( this.wmuSelectOptionElementList[i].getAttribute( 'value' ) ) )
			{
				this.wmuSelectOptionElementList[i].classList.add( 'selected' );
				element = document.createElement( 'div' );
				element.classList.add( 'wmu-select-selection-item' );
				element.innerHTML = this.wmuSelectOptionElementList[i].innerHTML;
				this.wmuSelectSelectionElement.appendChild( element );
			}
			else
			{
				this.wmuSelectOptionElementList[i].classList.remove( 'selected' );
			}
		}

		if ( 0 === selection.length )
		{
			this.wmuSelectElement.classList.add( 'empty' );
		}
		else
		{
			this.wmuSelectElement.classList.remove( 'empty' );
		}

		if ( updateRealSelect )
		{
			this.updateRealSelect();
		}
	}

	/**
	 * 
	 */
	updateRealSelect()
	{
		let selection;

		if ( false === this.isMultiple )
		{
			selection = ( this.selection ) ? [ this.selection ] : [];
		}
		else
		{
			selection = this.selection;
		}

		if ( null === this.selectOptions )
		{
			this.selectOptions = this.selectElement.querySelectorAll( 'option' );
		}

		let value;
		const countOptions = this.selectOptions.length;

		// First remove all selected to avoid problem on not multiple select when we set a second item selected
		for ( let i = 0; i < countOptions; i++ )
		{
			this.selectOptions[i].removeAttribute( 'selected' );
		}

		let lastSelectedIndex = -1;
		for ( let i = 0; i < countOptions; i++ )
		{
			value = this.selectOptions[i].getAttribute( 'value' );

			if ( value && -1 !== selection.indexOf( value ) )
			{
				// this.selectOptions[i].setAttribute( 'selected', 'selected' );
				this.selectOptions[i].setAttribute( 'selected', '' );
				lastSelectedIndex = i;
			}
		}

		/**
		 * @note Test pour Safari...
		 */
		if ( -1 !== lastSelectedIndex )
		{
			this.selectElement.selectedIndex = lastSelectedIndex;
		}

		/**
		 * @note tentative de forcer value systématiquement.
		 */
		this.selectElement.value = selection.join(',');
	}

	/**
	 * 
	 */
	updateStatus()
	{
		if ( true === this.isOpen )
		{
			this.wmuSelectElement.classList.add( 'open' );
		}
		else
		{
			this.wmuSelectElement.classList.remove( 'open' );
		}
	}

	/**
	 * 
	 */
	close()
	{
		if ( true === this.isOpen )
		{
			this.stopKeyboardControls();
		}

		this.isOpen = false;
		this.updateStatus();
	}

	/**
	 * 
	 */
	open()
	{
		this.isOpen = true;
		this.updateStatus();
		this.startKeyboardControls();
	}

	/**
	 * 
	 */
	toggleOpen()
	{
		if ( false === this.isOpen )
		{
			this.open();
		}
		else
		{
			this.close();
		}
	}

	/**
	 * Initialize behaviors
	 * 
	 * @returns void
	 */
	initBehaviors()
	{
		this.onToggleOpen = this.onToggleOpen.bind( this );
		this.wmuSelectUIElement.addEventListener( 'click', this.onToggleOpen );

		const countOptions = this.wmuSelectOptionElementList.length;
		for ( let i = 0; i < countOptions; i++ )
		{
			this.wmuSelectOptionElementList[i].addEventListener( 'click', ( event ) =>
			{
				this.select( this.wmuSelectOptionElementList[i].getAttribute( 'value' ) );
			} );
		}

		this.onClickOutside = this.onClickOutside.bind( this );
		document.addEventListener( 'click', this.onClickOutside );

		this.onRealSelectChange = this.onRealSelectChange.bind( this );
		this.onRealSelectFocusIn = this.onRealSelectFocusIn.bind( this );
		this.onRealSelectFocusOut = this.onRealSelectFocusOut.bind( this );
		this.onRealSelectKeydown = this.onRealSelectKeydown.bind( this );
		this.onRealSelectKeyUp = this.onRealSelectKeyUp.bind( this );
		this.onKeyDown = this.onKeyDown.bind( this );
		this.selectElement.addEventListener( 'change', this.onRealSelectChange );
		this.selectElement.addEventListener( 'focusin', this.onRealSelectFocusIn );
		this.selectElement.addEventListener( 'focusout', this.onRealSelectFocusOut );
		this.selectElement.addEventListener( 'keydown', this.onRealSelectKeydown );
		this.selectElement.addEventListener( 'keyup', this.onRealSelectKeyUp );
	}

	/**
	 * 
	 * @param {*} event 
	 */
	onClickOutside( event )
	{
		if ( event && event.target && event.target.closest )
		{
			if ( this.wmuSelectElement === event.target.closest( '.wmu-select' ) )
			{
				return;
			}
		}
	
		if ( true === this.isOpen )
		{
			this.close();
		}
	}

	/**
	 * 
	 * @returns 
	 */
	onToggleOpen( event )
	{
		this.toggleOpen();
	}

	/**
	 * Find label from existing select
	 * 
	 * @returns string
	 */
	findLabel()
	{
		let label = null;

		if ( this.selectElement )
		{
			if ( label = this.selectElement.getAttribute( 'aria-label' ) )
			{
				return label;
			}

			if ( this.selectId )
			{
				const labelElement = document.querySelector( 'label[for="' + this.selectId +'"]' );

				if ( labelElement && labelElement.textContent )
				{
					return labelElement.textContent;
				}
			}
		}

		return label;
	}

	/**
	 * Find selection from existing select
	 * 
	 * @returns string|array
	 */
	findSelection()
	{
		const countOptions = this.selectOptions.length;
		const selection = [];

		for ( let i = 0; i < countOptions; i++ )
		{
			if ( this.selectOptions[i].getAttribute( 'selected' ) )
			{
				selection.push( this.selectOptions[i].getAttribute( 'value' ) );
			}
		}

		return ( this.selectMultiple ) ? selection : selection.shift();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onRealSelectChange( event )
	{
		if ( ! event.detail || ! event.detail.wmuSelect )
		{
			// console.log( 'onRealSelectChange', event, this.selectElement );
			this.select( this.selectElement.value, false, false );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onRealSelectFocusIn( event )
	{
		this.startKeyboardControls();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onRealSelectFocusOut( event )
	{
		this.stopKeyboardControls();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onRealSelectKeydown( event )
	{
		/**
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/keyup_event#ignoring_keyup_during_ime_composition
		 */
		if ( event.isComposing || event.keyCode === 229 )
		{
			return;
		}

		// Tab key
		if ( event.keyCode === 9 )
		{
			return;
		}

		event.preventDefault();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onRealSelectKeyUp( event )
	{
		/**
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/keyup_event#ignoring_keyup_during_ime_composition
		 */
		if ( event.isComposing || event.keyCode === 229 )
		{
			return;
		}

		// Tab key
		if ( event.keyCode === 9 )
		{
			return;
		}

		event.preventDefault();
	}

	/**
	 * 
	 */
	startKeyboardControls()
	{
		if ( false === this.isKeyboardControlsActive )
		{
			document.addEventListener( 'keydown', this.onKeyDown );
			this.isKeyboardControlsActive = true;
		}
	}

	/**
	 * 
	 */
	stopKeyboardControls()
	{
		if ( true === this.isKeyboardControlsActive )
		{
			document.removeEventListener( 'keydown', this.onKeyDown );
			this.isKeyboardControlsActive = false;
			this.resetKeyboardNav();
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onKeyDown( event )
	{
		const keyCode = event.keyCode;
		const key = event.key;
		const time = event.timeStamp;

		/**
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/keyup_event#ignoring_keyup_during_ime_composition
		 */
		if ( event.isComposing || keyCode === 229 )
		{
			return;
		}

		switch ( keyCode )
		{
			default:
				if ( key.length === 1 && null !== key.match( /^[a-zA-Z0-9_éèêëàâäçùüû'\-]+$/gi ) )
				{
					if ( this.keydownTime < time - 1000 )
					{
						this.searchString = '';
					}

					this.searchString += key;
					this.keydownTime = time;

					this.keyboardNavIndex = this.searchOptionIndex( this.searchString );
					this.updateKeyboardNav();
				}
				break;
			
			// Escape
			case 27:
				this.close();
				break;

			// Space
			case 32:
				if ( true === this.isMultiple )
				{
					if ( false === this.isOpen )
					{
						this.open();
					}
					else
					{
						this.selectByKeyboardNav();
					}
				}
				else
				{
					this.toggleOpen();
				}
				break;

			// Arrow up
			case 38:
				this.keyboardNavIndex--;
				this.updateKeyboardNav();
				break;
			
			// Arrow down
			case 40:
				this.keyboardNavIndex++;
				this.updateKeyboardNav();
				break;
		}
	}

	/**
	 * 
	 * @param {String} searchString 
	 */
	searchOptionIndex( searchString )
	{
		const countOptions = this.wmuSelectOptionElementList.length;
		let entry;
		searchString = this.removeAccent( searchString.toLowerCase() );

		for ( let i = 0; i < countOptions; i++ )
		{
			entry = this.wmuSelectOptionElementList[ i ].innerHTML;
			entry = entry.trim();
			entry = entry.replace( /<\/?[^>]+(>|$)/g, "" );
			entry = entry.toLowerCase();
			entry = this.removeAccent( entry );

			if ( null !== entry.match(new RegExp( `^${searchString}`, 'g' ) ) )
			{
				return i;
			}
		}

		return 0;
	}

	/**
	 * 
	 */
	selectByKeyboardNav()
	{
		const countOptions = this.wmuSelectOptionElementList.length;
		for ( let i = 0; i < countOptions; i++ )
		{
			if ( i === this.keyboardNavIndex )
			{
				this.select( this.wmuSelectOptionElementList[ i ].getAttribute( 'value' ), false );
			}
		}
	}

	/**
	 * 
	 */
	resetKeyboardNav()
	{
		this._keyboardNavIndex = null;
		
		const countOptions = this.wmuSelectOptionElementList.length;
		for ( let i = 0; i < countOptions; i++ )
		{
			this.wmuSelectOptionElementList[ i ].classList.remove( 'hover' );
		}
	}

	/**
	 * 
	 */
	updateKeyboardNav()
	{
		if ( false === this.isOpen )
		{
			this.selectByKeyboardNav();
		}
		else
		{
			const countOptions = this.wmuSelectOptionElementList.length;
			let selectedIndex;

			for ( let i = 0; i < countOptions; i++ )
			{
				if ( i === this.keyboardNavIndex )
				{
					this.wmuSelectOptionElementList[ i ].classList.add( 'hover' );
					selectedIndex = i;
				}
				else
				{
					this.wmuSelectOptionElementList[ i ].classList.remove( 'hover' );
				}
			}

			if ( false === this.isMultiple )
			{
				this.selectByKeyboardNav();
			}
	
			this.scrollToOption( this.wmuSelectOptionElementList[ selectedIndex ] );
		}
	}

	/**
	 * 
	 * @param {HTMLElement} optionElement 
	 */
	scrollToOption( optionElement )
	{
		if ( optionElement )
		{
			const optionRect = optionElement.getBoundingClientRect();
			const optionListRect = this.wmuSelectOptionsElement.getBoundingClientRect();

			if ( optionRect.top < optionListRect.top )
			{
				this.wmuSelectOptionsElement.scrollTop -= optionListRect.top - optionRect.top;
			}
			else if ( optionRect.bottom > optionListRect.bottom )
			{
				this.wmuSelectOptionsElement.scrollTop += optionRect.bottom - optionListRect.bottom;
			}
		}
	}

	accentCharMatch = {"à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","è":"e","é":"e","ê":"e","ë":"e","ç":"c","ì":"i","í":"i","î":"i","ï":"i","ù":"u","ú":"u","û":"u","ü":"u","ÿ":"y","ñ":"n","-":" ","_":" "};

	/**
	 * 
	 * @param {String} entry 
	 */
	removeAccent( entry )
	{
		const reg = /[àáäâèéêëçìíîïòóôõöøùúûüÿñ_-]/gi;
		return entry.replace( reg, ( char ) => this.accentCharMatch[ char.toLowerCase() ] ).toLowerCase();
	}

}

export default WMUSelect;